/**
 * Documents API
 * Domain API via HTTP transport (apiTransport) to the backend /api RPC.
 */

import { apiTransport as router } from './transport';
import { getContext } from './core';
import { FileRecord, DocumentCategory, DocumentTag } from '@repo/shared-types';

// GET /documents/library/search and /documents/tags: HOLLOW empty lists until library search is implemented.
export const documentsApi = {
  library: {
    search: async (filters: Record<string, unknown>) => {
      const query = new URLSearchParams(filters as Record<string, string>).toString();
      return router.get<FileRecord[]>(`/documents/library/search?${query}`);
    },
    categories: {
      list: async () => router.get<DocumentCategory[]>('/documents/categories'),
      create: async (category: Partial<DocumentCategory>) => {
        const context = getContext();
        return router.post<DocumentCategory>('/documents/categories', category, context);
      }
    },
    tags: {
      list: async () => router.get<DocumentTag[]>('/documents/tags'),
      search: async (params: Record<string, unknown>) => {
        const query = new URLSearchParams(params as Record<string, string>).toString();
        return router.get<FileRecord[]>(`/documents/library/search?${query}`);
      },
      create: async (tag: Partial<DocumentTag>) => {
        const context = getContext();
        return router.post<DocumentTag>('/documents/tags', tag, context);
      }
    }
  }
};

